import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { FileDown } from "lucide-react";

export function PartnerListExport({ list, label }) {
  const [open, setOpen] = useState(false);
  const [contact, setContact] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/partner-list/pdf", { ids: list.map((c) => c.id), with_contact: contact, label }, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = "Partner-Sponsoren.pdf"; a.click();
      URL.revokeObjectURL(url);
      setOpen(false);
    } catch (e) { toast.error(apiError(e.response?.data?.detail) || "Export fehlgeschlagen"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} disabled={!list.length} data-testid="partner-list-export-button"><FileDown size={16} className="mr-1.5" /> PDF-Export</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="partner-list-export-dialog">
          <DialogHeader>
            <DialogTitle>Übersicht als PDF</DialogTitle>
            <DialogDescription>{list.length} {list.length === 1 ? "Eintrag" : "Einträge"} aus der aktuellen Liste{label ? ` (${label})` : ""} – mit Freianzeige, Leistungen, Werbeflächen und Laufzeiten.</DialogDescription>
          </DialogHeader>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={contact} onChange={(e) => setContact(e.target.checked)} data-testid="partner-list-export-contact" />
            Kontaktdaten aufnehmen (Ansprechpartner, E-Mail, Telefon)
          </label>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="partner-list-export-cancel">Abbrechen</Button>
            <Button onClick={run} disabled={busy} className="bg-[#0B132B] hover:bg-[#1C2541]" data-testid="partner-list-export-run">{busy ? "Wird erstellt …" : "PDF erstellen"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
